import type { SkillCatalogSkill, SkillTier } from "connected-components/skills/types"
import { formatLastUpdated } from "connected-components/skills/utils/format"

const TIER_LABELS: Record<SkillTier, string> = { licensed: "Core", proprietary: "Tailored" }

export function tierLabel(tier: SkillTier): string {
  return TIER_LABELS[tier]
}

export function formatSkillMeta(skill: SkillCatalogSkill, { withAuthor = false } = {}): string {
  const parts = [`v${skill.version}`]
  const updated = formatLastUpdated(skill.lastUpdated)
  if (updated) parts.push(`Updated ${updated}`)
  if (withAuthor && skill.author) parts.push(skill.author)
  return parts.join(" · ")
}
